/**
 * NotificationStatsData 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * NotificationStatsData
 */
export interface NotificationStatsData {
  /** 总发送数 */
  total_sent?: number
  /** 已读数 */
  total_read?: number
  /** 点击数 */
  total_clicked?: number
  /** 读取率 */
  read_rate?: number
  /** 点击率 */
  click_rate?: number
}

/**
 * NotificationStatsData Schema
 */
export const NotificationStatsDataSchema: SchemaDefinition = {
  properties: {
    total_sent: {
      description: '总发送数',
      format: 'int',
      type: 'integer',
      label: '总发送数',
    },
    total_read: {
      description: '已读数',
      format: 'int',
      type: 'integer',
      label: '已读数',
    },
    total_clicked: {
      description: '点击数',
      format: 'int',
      type: 'integer',
      label: '点击数',
    },
    read_rate: {
      description: '读取率',
      format: 'float64',
      type: 'number',
      label: '读取率',
    },
    click_rate: {
      description: '点击率',
      format: 'float64',
      type: 'number',
      label: '点击率',
    },
  },
  type: 'object',
}
